
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/account/downloads",
      function () {
        return require("private-next-pages/d/account/downloads.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/account/downloads"])
      });
    }
  